import React from 'react'

export function Card({ children, className = '' }) {
  return <div className={`surface-card ${className}`.trim()}>{children}</div>
}

export function CardHeader({ title, subtitle, action }) {
  return (
    <div className="section-head">
      <div>
        <h3>{title}</h3>
        {subtitle ? <p>{subtitle}</p> : null}
      </div>
      {action}
    </div>
  )
}
